import React from 'react';


function LoaderFailed({ isLoader }) {
  return (
    <>
      {isLoader && (
        <div className="spinner_overlay">
          <div className="loader">
          <span>Loading failed</span>
          </div>
        </div>
      )}
    </>
  );
}

export default LoaderFailed;